import { render, staticRenderFns } from "./update-performance.vue?vue&type=template&id=64dfbf85&scoped=true&"
import script from "./update-performance.vue?vue&type=script&lang=js&"
export * from "./update-performance.vue?vue&type=script&lang=js&"
import style0 from "./update-performance.vue?vue&type=style&index=0&id=64dfbf85&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dfbf85",
  null
  
)

export default component.exports